

import React, { memo } from 'react';

import VideoPlaceholder from '../../VideoPlaceholder';
import PlayerVideo from './PlayerVideo';
import { getPlaceholderProps } from '../utils';

import '../styles/_player-content.scss';















const PlayerContent = ({
  asset,
  customPlaceholder,
  selectedCaption,
  assetError,
  assetMissing,
  transcodeFailed,
  transcoding,
  source,
  setVideoRef,
  isMusicV2,
  bgmImage
}) => {
  if (asset === void 0) {
    return null;
  }

  if (asset === null || assetError || assetMissing || transcodeFailed) {
    const placeholderProps = getPlaceholderProps({ asset, assetError, transcodeFailed });

    return (
      customPlaceholder ||
      <VideoPlaceholder
        className="player-content__placeholder"
        iconColor="michael"
        {...placeholderProps} />);



  }

  if (transcoding) {
    return (
      customPlaceholder ||
      <VideoPlaceholder
        className="player-content__placeholder"
        darkTheme
        subtitle="We're getting your video ready." />);



  }

  return (
    <PlayerVideo
      isMusicV2={isMusicV2}
      bgmImage={bgmImage}
      asset={asset}
      selectedCaption={selectedCaption}
      setVideoRef={setVideoRef}
      source={source} />);


};

export default memo(PlayerContent);